// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trail-grid__controls{border-bottom:1px solid var(--pale-sky-blue)}", ""]);
// Exports
module.exports = exports;
